import { StandardForm, FormField, FormInputGroup, TextInput, FormError, FlexBox, Button } from '@vp/swan';
import React, { useContext, useState } from 'react';
import { validateEmail, validateOrderNumber } from './src-utils-validation-utils.js';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';

const NonLoggedInOrderForm = ({ onSubmit }) => {
  const {
    state: { sendChatbotMessage }
  } = useContext(ChatbotContext);
  const [formData, setFormData] = useState({ email: "", orderNumber: "" });
  const [errors, setErrors] = useState({ email: "", orderNumber: "" });
  const [touched, setTouched] = useState({ email: false, orderNumber: false });
  const handleBlur = (field) => {
    setTouched({ ...touched, [field]: true });
    if (field === "email") {
      setErrors({ ...errors, [field]: validateEmail(formData[field]) });
    }
  };
  const validateForm = () => {
    const newErrors = {
      email: validateEmail(formData.email),
      orderNumber: validateOrderNumber(formData.orderNumber)
    };
    setErrors(newErrors);
    setTouched({ email: true, orderNumber: true });
    return !Object.values(newErrors).some((error) => error !== "");
  };
  const handleSubmit = () => {
    if (validateForm()) {
      const formattedOrderNumber = formData.orderNumber.toUpperCase();
      sendChatbotMessage?.({
        type: "non_logged_in_order_tracking",
        messageData: {
          messageText: `${formData.email}
${formattedOrderNumber}`,
          // Display to user
          query: `Order ID - ${formattedOrderNumber}`,
          email: formData.email
        }
        // Send query to the chatbot
      });
      onSubmit?.({
        email: formData.email,
        orderNumber: formattedOrderNumber
      });
    }
  };
  return /* @__PURE__ */ React.createElement(StandardForm, { compactMode: true, marginY: "between-actions" }, /* @__PURE__ */ React.createElement(FormField, null, /* @__PURE__ */ React.createElement(FormInputGroup, null, /* @__PURE__ */ React.createElement(
    TextInput,
    {
      value: formData.email,
      onChange: (e) => setFormData({ ...formData, email: e.target.value }),
      onBlur: () => handleBlur("email"),
      placeholder: "Email linked to your VistaPrint account"
    }
  ), touched.email && errors.email && /* @__PURE__ */ React.createElement(FormError, null, errors.email))), /* @__PURE__ */ React.createElement(FormField, null, /* @__PURE__ */ React.createElement(FormInputGroup, null, /* @__PURE__ */ React.createElement(
    TextInput,
    {
      value: formData.orderNumber,
      onChange: (e) => setFormData({ ...formData, orderNumber: e.target.value }),
      onBlur: () => handleBlur("orderNumber"),
      placeholder: "Order number"
    }
  ), touched.orderNumber && errors.orderNumber && /* @__PURE__ */ React.createElement(FormError, null, errors.orderNumber))), /* @__PURE__ */ React.createElement(FlexBox, { justifyContent: "space-around" }, /* @__PURE__ */ React.createElement(Button, { onClick: handleSubmit, skin: "primary" }, "Confirm")));
};

export { NonLoggedInOrderForm as default };
//# sourceMappingURL=src-components-NonLoggedInOrderForm-NonLoggedInOrderForm.js.map
